<div class="modal-header py-2 bg-dark text-light">
    <h4 class="modal-title">
        <i class="mdi mdi-car"></i>
        공회전+고RPM 상세
    </h4>
</div>

<div class="modal-body">
    <div class="row">
        <div class="col-auto">
            <div class="table-responsive">
                <table class="table table-sm table-hover align-items-center mb-0">
                    <thead class="">
                        <tr>
                            <th>
                                운행일시
                            </th>
                            <th>
                                RPM
                            </th>
                        </tr>
                    </thead>
                    <tbody class="">
                        <tr *ngFor="let item of listItem;">
                            <td>
                                <span>{{item.dtgRegDt | date:'yyyy-MM-dd HH:mm:ss' || '-'}}</span>
                            </td>
                            <td>
                                <span>
                                    {{item.dtgRpm | number}}
                                    /
                                    {{item.dtgCheckRpm | number}}
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="mt-3">
                <list-paging
                    [inputPagingInfo]="pagingInfo"
                    (callbackClickPageNumber)="callbackClickPageNumber($event)"
                    (callbackChangeCountRowPerPage)="callbackChangeCountRowPerPage($event)"></list-paging>
            </div>
        </div>
        <div class="col">
            <div id="chart-01" style="height: 300px;"></div>
        </div>
    </div>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary btn-sm"
        (click)="clickCancel()">
        <i class="mdi mdi-close"></i>
        취소
    </button>
</div>